module.exports = __webpack_public_path__ + "media/theme/search-fab01d49.svg";